export enum StickyPositionEnum {
  top = 'top',
  bottom = 'bottom',
}
